export const getClosestAspectRatio = (ratio: number): string => {
  const ratios = [
    { class: "1/1", value: 1 },
    { class: "4/3", value: 4/3 },
    { class: "3/2", value: 3/2 },
    { class: "16/9", value: 16/9 },
    { class: "2/1", value: 2 },
  ];

  return ratios.reduce((closest, current) => 
    Math.abs(current.value - ratio) < Math.abs(closest.value - ratio) ? current : closest
  ).class;
};